import React, { Component } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Icon,
  CircularProgress,
} from "@material-ui/core";
import Http from "../../../Http";
import { Button } from "react-bootstrap";

export default class GuiaComment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingSave: false,
      openForm: false,
      comentario: "",
      id_guia: false,
      comentarios: [],
      sbOpen: false,
      sbMsg: "",
    };
  }

  componentDidMount() {
    this.getInfo(this.props.guia.id);
    this.setState({ id_guia: this.props.guia.id });
  }

  getInfo = async (id_guia) => {
    this.setState({ loadingData: true });
    const Res = await Http.get(
      `guia-comentario/${id_guia}/historial`
    );
    if (Res && Res.data) {
      this.setState({ comentarios: Res.data.reverse() });
    }
    this.setState({ loadingData: false });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.guia.id !== this.props.guia.id) {
      this.getInfo(this.props.guia.id);
      this.setState({ id_guia: this.props.guia.id });
    }
  }

  downloadImage = (link) => {
    let a = document.createElement('a');
    a.href = link;
    a.download = link;
    a.target = "_blank"
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  render() {
    const { comentarios, loadingData } = this.state;
    return (
      <div>
        {loadingData ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CircularProgress />
            Cargando
          </div>
        ) : (
          <div>
            {comentarios.length > 0 ? (
              comentarios.map((comment) => (
                <Accordion key={comment.id}>
                  <AccordionSummary
                    expandIcon={<Icon>expand_more_icon</Icon>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    disabled={!comment.link_evidencia}
                  >
                    <Typography>
                      <strong>
                        {comment.createdAt} / {comment.g_estado_descripcion} /
                        {comment.usuario}
                      </strong>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{comment.comentario}</Typography>
                    <div
                      style={{
                        height: 300,
                        width: 500,
                        backgroundImage: `url(${comment.link_evidencia})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                    <div>
                      <Button
                        color={"primary"}
                        variant={"contained"} 
                        onClick={()=> { this.downloadImage(comment.link_evidencia) }}
                        >
                        Descargar Imagen
                      </Button>
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <span>Sin Comentarios</span>
            )}
          </div>
        )}
      </div>
    );
  }
}
